import React from "react";

export default function BsTwitter() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.325 1.03125H20.6992L13.3293 9.4765L22 20.9688H15.2116L9.8945 13.9975L3.81012 20.9688H0.4345L8.31738 11.935L0 1.03125H6.96163L11.7672 7.40162L17.325 1.03125ZM16.1425 18.9447H18.0125L5.94413 2.94937H3.93937L16.1425 18.9447Z"
        fill="currentColor"
      />
    </svg>
  );
}
